import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  validarProcedimiento: ["payload"],
  validarProcedimientoLoading: null,
  validarProcedimientoSuccess: ["validarProcedimientoData"],
  validarProcedimientoFailure: ["validarProcedimientoError"],

  eliminarProcedimiento: ["payload"],
  eliminarProcedimientoLoading: null,
  eliminarProcedimientoSuccess: ["eliminarProcedimientoData"],
  eliminarProcedimientoFailure: ["eliminarProcedimientoError"],
});

export { Types };

export default Creators;